import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class PressQuotes extends UcoastEl {
    static htmlSelector = 'press-quotes'
    sliderContainer: HTMLElement
    contentToggles: NodeListOf<HTMLElement>
    detailsItems: NodeListOf<HTMLDetailsElement>
    scroller: HTMLElement
    container: HTMLElement
    leftPos: number = 0
    currentIndex: number = 0
    minHeight: number = 300
    timing: number
    isPaused = true
    animationFrameId?: number
    lastTimestamp?: number
    constructor() {
        super()
        this.contentToggles = q.rl('[data-uc-press-quotes-toggle-item]', this)
        this.detailsItems = q.rl('[data-uc-press-quotes-details-item]', this)
        this.sliderContainer = q.rs('[data-uc-press-quotes-slider]', this)
        this.scroller = q.rs('[data-uc-press-quotes-scroller]', this)
        this.container = q.rs('[data-uc-press-quotes-container]', this)
        this.timing = parseInt(q.ra(this, 'data-uc-press-quotes-timing')) * 1200
        this.doAnimate = this.doAnimate.bind(this);
    }

    override connectedCallback() {
        super.connectedCallback()
        this.open()
        this.contentToggles.forEach((toggle) => {
            toggle.addEventListener('click', (e) => {
                e.preventDefault()
                this.pauseAnimation()
                const index = parseInt(q.ra(toggle, 'data-uc-press-quotes-toggle-item'))
                this.setCurrentIndex(index)
                this.open()
            })
        })
    }
    setCurrentIndex(index: number) {
        this.currentIndex = index
    }
    open() {
        for (let i = 0; i < this.detailsItems.length; i++) {
            const contentToggle = this.contentToggles[i]
            const detailsItem = this.detailsItems[i]
            if (i === this.currentIndex) {
                detailsItem.classList.add('active')
                contentToggle.classList.add('active')
                this.sliderContainer.style.minHeight = `${detailsItem.scrollHeight}px`
                this.scrollAction(contentToggle)
            } else {
                contentToggle.classList.remove('active')
                detailsItem.classList.remove('active')
            }
        }
    }
    scrollAction(contentToggle: HTMLElement) {
        if (this.scroller.clientWidth > this.container.clientWidth) {
            const containerLeft = this.container.getBoundingClientRect().left
            const toggleLeft = contentToggle.getBoundingClientRect().left
            const leftPos = (toggleLeft - containerLeft) + this.leftPos;
            this.leftPos = leftPos
            this.scroller.style.transform = `translateX(-${this.leftPos}px)`
        }
    }
    getNextIndex() {
        const size = this.detailsItems.length
        if (this.currentIndex === size - 1) {
            return 0
        } else {
            return this.currentIndex + 1
        }
    }
    doAnimate(timestamp: number) {
        if (this.isPaused) return
        const delta = this.lastTimestamp ? timestamp - this.lastTimestamp : 0;
        if (delta > this.timing) {
            this.lastTimestamp = timestamp;
            this.setCurrentIndex(this.getNextIndex())
            this.open()
        } else if (!this.lastTimestamp) {
            this.lastTimestamp = timestamp;
        }
        this.animationFrameId = requestAnimationFrame(this.doAnimate)
    }
    startAnimation() {
        if (!this.isPaused) return
        this.isPaused = false
        this.lastTimestamp = undefined
        this.animationFrameId = requestAnimationFrame(this.doAnimate.bind(this))
    }
    pauseAnimation() {
        this.isPaused = true
        if (this.animationFrameId) {
            cancelAnimationFrame(this.animationFrameId)
        }
    }
    override animateIn() {
        this.startAnimation()
    }
    override animateOut() {
        this.pauseAnimation()
    }
}
